<template>
    <div>
        <div :class="customStyle ? customStyle : 'grid grid-cols-1 sm:grid-cols-2'">
            <div :class="pinStyle1">
                <InputPasswordNumber
                    v-model:inputValue="formData.pin"
                    :errorInfo="errorInfo[0]"
                    :inputLbl="lbl.register.form.pin"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isFirstSave="isFirstSave"
                    :minLength="8"
                    :maxLength="8"
                    :isShowPassword="true"
                    :isShowTextPassword="true"
                ></InputPasswordNumber>
            </div>
            <div :class="pinStyle2">
               <InputPasswordNumber
                    v-model:inputValue="formData.confirmpin"
                    :errorInfo="errorInfo[1]"
                    :inputLbl="lbl.register.form.pinConfirm"
                    :isShowErrorLbl="true"
                    :isShowStar="true"
                    :isFirstSave="isFirstSave"
                    :minLength="8"
                    :maxLength="8"
                    :isShowPassword="true"
                ></InputPasswordNumber>
            </div>
        </div>
    </div>
</template>

<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import InputPasswordNumber from "@/components/Input/simple/InputPasswordNumber.vue";
export default {
    name: 'Password',
    mixins: [LocaleMixin],
    components:{
        InputPasswordNumber,
    },
    props:{
        form: Object,
        errorInfo: Array,
        isFirstSave: Boolean,
        customStyle: { type:String , default: ''},
        pinStyle1: { type:String , default: 'px-5px pt-4'},
        pinStyle2: { type:String , default: 'px-5px pt-4'},
    },
    data: function(){
        return{
            formData: {},
        }
    },
    created: function(){
        this.formData = this.form
    }
};
</script>

<style lang="scss" scoped>

</style>
